import * as Yup from "yup";

export interface EmailFormValues {
	email: string;
}

export const emailValidationSchema = Yup.object({
	email: Yup.string()
		.email("Please enter a valid email address")
		.required("Email is required"),
});
